import { c as _c } from "react/compiler-runtime";
import { Badge } from '@chakra-ui/react';
import { ratingColorPalette } from '@src/components/sco/PitchDeckAuditor/model/ratingMeta';
import { RatingKey } from '@src/components/sco/PitchDeckAuditor/model/types';
export function RatingBadge(t0) {
  const $ = _c(7);
  const {
    ratingKey,
    label,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const variant = t2 === undefined ? "subtle" : t2;
  let t3;
  if ($[0] !== ratingKey) {
    t3 = ratingColorPalette(ratingKey);
    $[0] = ratingKey;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = label || ratingKey;
  let t5;
  if ($[2] !== size || $[3] !== t3 || $[4] !== t4 || $[5] !== variant) {
    t5 = <Badge colorPalette={t3} size={size} variant={variant}>{t4}</Badge>;
    $[2] = size;
    $[3] = t3;
    $[4] = t4;
    $[5] = variant;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}